import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { getMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  symbol: string;
};

export default function QuoteVolume({ symbol }: Props) {
  const { quoteVolume, priceDecimals, sizeDecimals } = useStore(
    getMarketStore(symbol),
    useShallow((state) => ({
      quoteVolume: state.marketData.quoteVolume ?? 0n,
      priceDecimals: state.marketSpec.priceDecimals,
      sizeDecimals: state.marketSpec.sizeDecimals,
    })),
  );
  return formatBigInt(quoteVolume, priceDecimals + sizeDecimals, {
    digits: 2,
    style: 'currency',
    compact: true,
  });
}

export const quoteVolumeAccessorFn = (symbol: string) => {
  const {
    marketData: { quoteVolume = 0n },
    marketSpec: { priceDecimals, sizeDecimals },
  } = getMarketStore(symbol).getState();
  return bigIntToNum(quoteVolume, priceDecimals + sizeDecimals);
};
